var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#0C0D14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.75C36.0941 14.75 42.25 20.9059 42.25 28.5C42.25 36.0941 36.0941 42.25 28.5 42.25C20.9059 42.25 14.75 36.0941 14.75 28.5C14.75 20.9059 20.9059 14.75 28.5 14.75ZM28.5 20.25C28.1353 20.25 27.7856 20.3949 27.5277 20.6527C27.2699 20.9106 27.125 21.2603 27.125 21.625V28.5C27.1251 28.8646 27.27 29.2143 27.5279 29.4721L31.6529 33.5971C31.9122 33.8476 32.2595 33.9862 32.6201 33.9831C32.9806 33.9799 33.3254 33.8353 33.5804 33.5804C33.8353 33.3254 33.9799 32.9806 33.9831 32.6201C33.9862 32.2595 33.8476 31.9122 33.5971 31.6529L29.875 27.9308V21.625C29.875 21.2603 29.7301 20.9106 29.4723 20.6527C29.2144 20.3949 28.8647 20.25 28.5 20.25Z",
    fill: "#F34D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpired);
export default __webpack_public_path__ + "static/media/icon-expired.7154bebea68bea84bd650aa04f1b596f.svg";
export { ForwardRef as ReactComponent };